import React from 'react'

import styled from '@emotion/styled'

const ProgressBar = ({ min, max, value, children }) => {
  return (
    <StyledDiv>
      <div
        className='c-progress__bar'
        role='progressbar'
        aria-valuenow={value}
        aria-valuemin={min}
        aria-valuemax={max}
        style={{ width: `calc((100% - 40px) * ${value / max})` }}
      />
      <div className='c-progress__val'>{children}</div>
    </StyledDiv>
  )
}

export default ProgressBar

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  height: 22px;
  min-width: 40px;

  .c-progress__bar {
    flex-grow: 0;

    height: 6px;
    border-radius: 3px;

    background-color: var(--silver);
  }

  .c-progress__val {
    flex-grow: 0;

    color: var(--boulder);
    font-style: italic;
    font-size: 12px;
    padding-left: 8px;
  }
`
